import BaseService from './BaseService';

class PermissionService extends BaseService {
    getUserPermissions = () => this.get('/warehouse/permission');
}

export default new PermissionService();
